import React from "react";
import Filter from '../../../components/CRM/Filter';
import ReferenceInput from "../../../components/CRM/ReferenceInput";
import TextInput from "../../../components/CRM/TextInput";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import DateInput from "../../../components/CRM/DateInput";

const DeviceFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="resources.devices.fields.storeName"
      source="kiosk_id"
      reference="kiosks"
      sort={{field: "name", order: "ASC"}}
      allowEmpty={false}
      filterToQuery={name => ({name_like: name})}
    >
      <AutocompleteInput
        optionText="name"
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>

    <TextInput
      label="resources.devices.fields.deviceSerialNumber"
      source="id_like"
    />

    <DateInput
      label="resources.devices.fields.lastReport"
      source="last_report_at_on_date"
    />
  </Filter>
);

export default DeviceFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/DeviceFilter.js